import { SpotlightSearchFilter } from '@/modules/spotlight/constants/SpotlightSearchFilter';

export const SpotlightSearchFilterValues: Record<SpotlightSearchFilter, boolean> = {
  [SpotlightSearchFilter.ESTATE_ASSIGNED_TO_ME]: false,
  [SpotlightSearchFilter.SHOW_CLOSED]: false,
  [SpotlightSearchFilter.SHOW_DELETED]: false
};
